
$(document).ready(function () {
    const heroTextOne = document.querySelector(".slide-1");
    const heroTextTwo = document.querySelector(".slide-2");
    const heroButton = document.querySelector(".slide-btn");
    const heroChicken = document.querySelector(".hero__chicken");

    







    ScrollTrigger.saveStyles(".mobile, .desktop");

    /*** Different ScrollTrigger setups for various screen sizes (media queries) ***/
    ScrollTrigger.matchMedia({
        // desktop
        "(min-width: 800px)": function () {
            // setup animations and ScrollTriggers for screens over 800px wide (desktop) here...
            // ScrollTriggers will be reverted/killed when the media query doesn't match anymore.


            var outHero1 = gsap.to(heroTextOne, {
                // autoAlpha: 0,
                x: 800,
                immediateRender: false,
                overwrite: "auto",
                scrollTrigger: {
                    trigger: "header",
                    start: "top+=20",
                    end: "bottom+=220",
                    markers: false,
                    scrub: true,
                },
            });

            var outHero2 = gsap.to(heroTextTwo, {
                x: -800,
                immediateRender: false,
                overwrite: "auto",
                scrollTrigger: {
                    trigger: "header",
                    start: "top+=40",
                    end: "bottom+=240",
                    markers: false,
                    scrub: true,
                },
            });

            var outHero3 = gsap.to(heroButton, {
                x: 800,
                immediateRender: false,
                overwrite: "auto",
                scrollTrigger: {
                    trigger: "header",
                    start: "top+=80",
                    end: "bottom+=280",
                    markers: false,
                    scrub: true,
                },
            });

            var outHero4 = gsap.to(heroChicken, {
                y: -200,
                immediateRender: false,
                overwrite: "auto",
                scrollTrigger: {
                    trigger: "header",
                    start: "top",
                    end: "bottom+=200",
                    markers: false,
                    scrub: true,
                },
            });
        },

        // mobile
        "(max-width: 799px)": function () {
            // Any ScrollTriggers created inside these functions are segregated and get
            // reverted/killed when the media query doesn't match anymore.

        },

        // all
        all: function () {
            // ScrollTriggers created here aren't associated with a particular media query,
            // so they persist.
                        var inHero1 = gsap.timeline();
                        inHero1.from(heroTextOne, {
                            scale: 0.01,
                            duration: 0.7,
                            ease: "back",
                            autoAlpha: 0,
                        });

                        var inHero2 = gsap.timeline();
                        inHero2.from(heroTextTwo, {
                            scale: 0.01,
                            duration: 0.7,
                            delay: 0.4,
                            ease: "back",
                            autoAlpha: 0,
                        });

                        var inHero3 = gsap.timeline();
                        inHero3.from(heroButton, {
                            scale: 0.01,
                            duration: 0.7,
                            delay: 0.8,
                            ease: "back",
                            autoAlpha: 0,
                        });

                        var inHeroChicken = gsap.timeline();
                        inHeroChicken.from(heroChicken, {
                            y: -200,
                            duration: 0.5,
                            delay: 1.2,
                            ease: "back",
                            autoAlpha: 0,
                        });
        },
    });





    AOS.init();


    // Nav toggle
    (function () {
        $(".nav-toggle").click(function () {
            $(".site-nav").slideToggle();
            $(this).toggleClass("open");
        });
    })();

    // Show menu
    (function () {
        $(".open-menu").click(function (e) {
            e.preventDefault();
            $("#menuPop").addClass('active');
        });
    })();

    // Show booking
    (function () {
        $(".open-booking").click(function (e) {
            e.preventDefault();
            $(".book-widget").slideToggle({
                start: function () {
                    $(this).css({
                        display: "flex",
                    });
                },
            });
            $('#book').toggleClass('open');
        });
    })();

    // Close modals
    (function () {
        $(".modal__close").click(function (e) {
            e.preventDefault();
            $(this).closest(".modal").removeClass("active");
        });
    })();

    //Show careers form
    (function () {
        $(".open-careers").click(function (e) {
            e.preventDefault();
            $(".contact-us__careers").addClass("active");
        });
    })();

    (function () {
        $(".close-careers").click(function (e) {
            e.preventDefault();
            $(".contact-us__careers").removeClass("active");
        });
    })();

    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, "") ==
                    this.pathname.replace(/^\//, "") &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length
                    ? target
                    : $("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $(".site-nav").slideUp();
                    $(".nav-toggle").removeClass("open");
                    $("html, body").animate(
                        {
                            scrollTop: target.offset().top - 120,
                        },
                        1000,
                        function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) {
                                // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        }
                    );
                }
            }
        });
});
